<template>
    <v-container fluid class="teams-page secondary-font">
        <template v-if="loading">
            <v-skeleton-loader type="heading" class="mb-3" max-width="300" />
            <v-row>
                <v-col v-for="n in 8" :key="n" cols="6" sm="4" md="3">
                    <v-skeleton-loader type="image" height="110" class="rounded-lg" />
                </v-col>
            </v-row>
        </template>

        <template v-else>
            <section v-if="myTeam" class="teams-group">
                <div class="teams-group__header">
                    <span class="teams-group__bar custom-orange" />
                    <span class="teams-group__title">Η ομάδα μου</span>
                </div>
                <v-row>
                    <v-col cols="6" sm="4" md="3">
                        <team-tile :team="myTeam" mine @open="goToTeam" />
                    </v-col>
                </v-row>
            </section>

            <section v-for="group in groups" :key="group.key" class="teams-group">
                <div class="teams-group__header">
                    <span class="teams-group__bar custom-orange" />
                    <span class="teams-group__title">{{ group.title }}</span>
                    <span class="teams-group__count">{{ group.teams.length }} {{ group.teams.length === 1 ? 'ομάδα' : 'ομάδες' }}</span>
                </div>
                <v-row>
                    <v-col v-for="team in group.teams" :key="team.id" cols="6" sm="4" md="3">
                        <team-tile :team="team" :mine="myTeam && myTeam.id === team.id" @open="goToTeam" />
                    </v-col>
                </v-row>
            </section>
        </template>
    </v-container>
</template>

<script>
    import teamService from '@/services/team'
    import TeamTile from '@/components/TeamTile'

    const NO_LEAGUE_KEY = 'no-league'

    export default {
        components: { TeamTile },
        data() {
            return {
                teams: [],
                loading: false
            }
        },
        computed: {
            visibleTeams() {
                return this.teams
                    .filter(team => team.name !== 'PLAYER POOL')
                    .sort((a, b) => a.name.localeCompare(b.name, 'el'))
            },
            groups() {
                const byKey = {}
                this.visibleTeams.forEach(team => {
                    const key = team.league ? String(team.league.id) : NO_LEAGUE_KEY
                    if (!byKey[key]) {
                        byKey[key] = {
                            key,
                            title: team.league ? team.league.title : 'Χωρίς κατηγορία',
                            teams: []
                        }
                    }
                    byKey[key].teams.push(team)
                })

                return Object.values(byKey).sort((a, b) => {
                    if (a.key === NO_LEAGUE_KEY) return 1
                    if (b.key === NO_LEAGUE_KEY) return -1
                    return a.title.localeCompare(b.title, 'el')
                })
            },
            myTeam() {
                const stored = this.$store.getters.getTeam
                if (!stored) {
                    return null
                }
                return this.visibleTeams.find(team => team.id === stored.id) || null
            }
        },
        created() {
            this.fetchAllTeams()
        },
        methods: {
            fetchAllTeams() {
                this.loading = true
                teamService.getTeams(1, 1000).then(resp => {
                    this.teams = resp.data.content
                }).finally(() => {
                    this.loading = false
                })
            },
            goToTeam(team) {
                this.$router.push({ name: 'Team', params: { id: team.id } })
            }
        }
    }
</script>

<style scoped>
.teams-page {
    max-width: 1200px;
    margin: 0 auto;
}

/* ---------- Groups ---------- */
.teams-group {
    margin-bottom: 24px;
}

.teams-group__header {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 14px;
    margin-bottom: 14px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    font-family: Ubuntu, Arial, sans-serif;
}

.teams-group__bar {
    width: 5px;
    height: 20px;
    border-radius: 2px;
}

.teams-group__title {
    font-weight: 800;
}

.teams-group__count {
    margin-left: auto;
    color: rgba(0, 0, 0, 0.5);
    font-size: 0.8rem;
    font-weight: 600;
}
</style>
